export interface IServerDashboardStats {
    applications_in_progress_total: number | null;
    applications_in_progress_7_days_total: number | null;
    applications_in_progress_7_days_change: number | null;
    applications_in_progress_30_days_total: number | null;
    applications_in_progress_30_days_change: number | null;
    applications_in_progress_90_days_total: number | null;
    applications_in_progress_90_days_change: number | null;
    applications_in_progress_365_days_total: number | null;
    applications_in_progress_365_days_change: number | null;
    new_resumes_total: number | null;
    new_resumes_7_days_total: number | null;
    new_resumes_7_days_change: number | null;
    new_resumes_30_days_total: number | null;
    new_resumes_30_days_change: number | null;
    new_resumes_90_days_total: number | null;
    new_resumes_90_days_change: number | null;
    new_resumes_365_days_total: number | null;
    new_resumes_365_days_change: number | null;
    open_positions_total: number | null;
    open_positions_7_days_total: number | null;
    open_positions_7_days_change: number | null;
    open_positions_30_days_total: number | null;
    open_positions_30_days_change: number | null;
    open_positions_90_days_total: number | null;
    open_positions_90_days_change: number | null;
    open_positions_365_days_total: number | null;
    open_positions_365_days_change: number | null;
}

export enum AlertSeverity {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
}

export enum AssignmentPriority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}

export type Duration = {
    value: number;
    unit: 'Min' | 'HR' | 'Days' | 'w';
};

export interface IClientNotification {
    id: string;
    date: string;
    description: string;
    severity: AlertSeverity;
}

export interface IServerNotification {
    id: number;
    params: {
        application_id: number;
    };
    created_at: string;
    updated_at: string;
    deleted: boolean;
    type: string;
    message: string;
    title: string | null;
    priority: string;
    is_read: boolean;
    user: number;
}

export enum DashboardTasksFormFields {
    newTasks = 'newTasks',
    editingTasks = 'editingTasks',
}

export enum DashboardTaskItemFields {
    id = 'id',
    completed = 'completed',
    priority = 'priority',
    dueDate = 'dueDate',
    description = 'description',
    duration = 'duration',
    title = 'title',
}

export interface IDashboardTaskItem {
    [DashboardTaskItemFields.id]: string;
    [DashboardTaskItemFields.completed]: boolean;
    [DashboardTaskItemFields.priority]: AlertSeverity;
    [DashboardTaskItemFields.dueDate]: string | null;
    [DashboardTaskItemFields.description]: string;
    [DashboardTaskItemFields.duration]: string;
    [DashboardTaskItemFields.title]: string;
}

export interface IDashboardTaskForm {
    [DashboardTasksFormFields.newTasks]: Array<IDashboardTaskItem>;
    [DashboardTasksFormFields.editingTasks]: Array<IDashboardTaskItem>;
}

export interface IServerDashboardJob {
    id: number;
    title: string;
    published_date: string;
    open_period: number;
    in_process: number;
    total_candidates: number;
}

export interface IClientDashboardJob {
    id: number;
    title: string;
    publishedDate: string;
    openPeriod: number;
    inProcess: number;
    totalCandidates: number;
}

export interface IClientAssignment {
    id: string;
    title?: string;
    description?: string;
    dueDate?: string;
    priority?: AlertSeverity | AssignmentPriority;
    isCompleted?: boolean;
    duration?: string | null;
}

export interface IServerAssignment {
    id: string;
    title?: string;
    description?: string;
    due_date?: string;
    priority?: AssignmentPriority;
    is_complete?: boolean;
    duration?: string | null;
}

export interface ITrackableStatisticsObject {
    entries: number;
    applications: number;
    percentOfEntries: number;
    percentOfApplications: number;
}

export interface IClientTrackableDataObject {
    public: Record<string, ITrackableStatisticsObject>;
    not_public: Record<string, ITrackableStatisticsObject>;
}

export interface IClientTrackableStatistics {
    week: IClientTrackableDataObject;
    month: IClientTrackableDataObject;
    quarter: IClientTrackableDataObject;
    year: IClientTrackableDataObject;
}

export interface ISourceRow {
    id: string;
    link: string;
    rank: number;
    entries: number;
    apply: number;
    percentage: number;
}
